'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagErAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.25849e-06 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33334 20 6.25849e-06 20C-4.03373e-05 13.3333 -4.03372e-05 6.66667 6.25849e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28 0V10H0L6.25849e-06 0H28Z",
          fill: "#29C53F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28 10V20H6.25849e-06L0 10H28Z",
          fill: "#579DED"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.25849e-06 20L28 10L6.25849e-06 0V20Z",
          fill: "#F42D56"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.66667 13.3333C10.5076 13.3333 12 11.8409 12 10C12 8.15905 10.5076 6.66667 8.66667 6.66667C6.82572 6.66667 5.33333 8.15905 5.33333 10C5.33333 11.8409 6.82572 13.3333 8.66667 13.3333ZM13.3333 10C13.3333 12.5773 11.244 14.6667 8.66667 14.6667C6.08934 14.6667 4 12.5773 4 10C4 7.42267 6.08934 5.33333 8.66667 5.33333C11.244 5.33333 13.3333 7.42267 13.3333 10Z",
          fill: "#FFC63C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.33333 8.00001C9.33333 8.3682 9.0349 8.66667 8.66671 8.66667C8.66671 9.03486 8.36823 9.33333 8.00004 9.33333C7.63185 9.33333 7.33337 9.03486 7.33337 8.66667C7.33337 8.29848 7.63185 8 8.00004 8C8.00004 7.63181 8.29848 7.33334 8.66667 7.33334C9.03486 7.33334 9.33333 7.63182 9.33333 8.00001Z",
          fill: "#FFC63C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.00004 10.6667C8.36823 10.6667 8.66671 10.3682 8.66671 10C8.66671 9.63182 8.36823 9.33333 8.00004 9.33333C7.63185 9.33333 7.33337 9.63182 7.33337 10C7.33337 10.3682 7.63185 10.6667 8.00004 10.6667Z",
          fill: "#FFC63C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.00004 10.6667C8.36823 10.6667 8.66671 10.9651 8.66671 11.3333C8.66671 11.7015 8.36823 12 8.00004 12C7.63185 12 7.33337 11.7015 7.33337 11.3333C7.33337 10.9651 7.63185 10.6667 8.00004 10.6667Z",
          fill: "#FFC63C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.33329 9.99999C9.70148 9.99999 9.99996 9.70151 9.99996 9.33332C9.99996 8.96513 9.70148 8.66666 9.33329 8.66666C8.9651 8.66666 8.66663 8.96513 8.66663 9.33332C8.66663 9.70151 8.9651 9.99999 9.33329 9.99999Z",
          fill: "#FFC63C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.33329 11.3333C8.9651 11.3333 8.66663 11.0349 8.66663 10.6667C8.66663 10.2985 8.9651 9.99999 9.33329 9.99999C9.70148 9.99999 9.99996 10.2985 9.99996 10.6667C9.99996 11.0349 9.70148 11.3333 9.33329 11.3333Z",
          fill: "#FFC63C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.33329 11.3333C8.9651 11.3333 8.66663 11.6318 8.66663 12C8.66663 12.3682 8.9651 12.6667 9.33329 12.6667C9.70148 12.6667 9.99996 12.3682 9.99996 12C9.99996 11.6318 9.70148 11.3333 9.33329 11.3333Z",
          fill: "#FFC63C"
        }
      )
    ]
  }
);
const VpFlagErAsset = forwardRef(FlagErAsset);

export { VpFlagErAsset as default };
